// Colors as specified in design system by Julo
const colors = {
  basic: {
    white: '#FFFFFF',
    black: '#000000',
    100: '#FFFFFF',
    200: '#F0F2FA',
    300: '#DBDFED',
    900: '#00001E', // rebranding
  },
  transparentWhite: {
    100: 'rgba(255, 255, 255, 0.1)',
    200: 'rgba(255, 255, 255, 0.2)',
    300: 'rgba(255, 255, 255, 0.3)',
    400: 'rgba(255, 255, 255, 0.4)',
    500: 'rgba(255, 255, 255, 0.5)',
    600: 'rgba(255, 255, 255, 0.6)',
    700: 'rgba(255, 255, 255, 0.7)',
    800: 'rgba(255, 255, 255, 0.8)',
    900: 'rgba(255, 255, 255, 0.9)',
  },
  transparentGray: {
    100: 'rgba(19, 31, 54, 0.1)',
    150: 'rgba(19, 31, 54, 0.15)',
    200: 'rgba(19, 31, 54, 0.2)',
    300: 'rgba(19, 31, 54, 0.3)',
    400: 'rgba(19, 31, 54, 0.4)',
    500: 'rgba(19, 31, 54, 0.5)',
    600: 'rgba(19, 31, 54, 0.6)',
    700: 'rgba(19, 31, 54, 0.7)',
    800: 'rgba(19, 31, 54, 0.8)',
    900: 'rgba(19, 31, 54, 0.9)',
  },
  solidGray: {
    100: '#E8E9EB',
    200: '#D0D2D7',
    300: '#B8BBC2',
    400: '#A1A5AF',
    500: '#898F9A',
    600: '#73737D', // rebranding
    700: '#596272',
    800: '#3C3C46', // rebranding
    900: '#2B364B',
  },
  brandPrimary: {
    100: '#E5EDFF', // rebranding
    150: '#BECFF7', // rebranding
    200: '#93B7F6',
    300: '#5B74E3',
    400: '#0A73EB', // rebranding
    500: '#0050FF', // rebranding
    600: '#00138D',
    700: '#00008C', // rebranding
    800: '#00095F',
    900: '#00064F',
  },
  brandSecondary: {
    100: '#CAFAFC',
    200: '#96EFFA',
    300: '#60D7F0',
    400: '#38B9E2',
    500: '#0090D0',
    600: '#006FB2',
    700: '#005395',
    800: '#003B78',
    900: '#002A63',
  },
  price: {
    100: '#C9FCEA',
    200: '#95F9DF',
    300: '#5FEFD6',
    400: '#38E0D1',
    500: '#00CCCC',
    600: '#00A0AF',
    700: '#007992',
    800: '#005776',
    900: '#003F61',
  },
  success: {
    100: '#F1FCD8',
    200: '#E1F9B4',
    300: '#C6EE8C',
    400: '#ADDE5F',
    500: '#91C90E',
    600: '#86B200',
    700: '#63942B',
    800: '#34741E',
    900: '#236016',
  },
  warning: {
    100: '#FFF8DA',
    200: '#FFEEB5',
    300: '#FFE391',
    400: '#FFD775',
    500: '#FFC548',
    600: '#DBA134',
    700: '#B77F24',
    800: '#936016',
    900: '#7A490D',
  },
  error: {
    100: '#FDE0D6',
    200: '#FCBAAD',
    300: '#F88B83',
    400: '#F16467',
    500: '#E83348',
    600: '#C72547',
    700: '#A71944',
    800: '#86103E',
    900: '#6F093A',
  },
  internal: {
    100: '#F2E2FB', //rebranding
    200: '#E0AFF4',
    300: '#CF81E0',
    400: '#B75BC1',
    500: '#952D98',
    600: '#772082',
    700: '#5C166D',
    800: '#430E58',
    900: '#310848',
  },
};

export default colors;
